import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  color: "text.primary",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const VideosFilter = (props) => {
  const TrimFilterRender = (props) => {
    const CheckBoxFilters = (name, addToTrimsToFilter, trimsToFilter, filterName) => {
      const handleChange = (event) => {
        addToTrimsToFilter(name, event.target.checked);
      };

      let checked = true;
      if (trimsToFilter.includes(name)) {
        checked = false;
      }

      const nameForFilter = filterName ? filterName : name;

      return (
        <FormControlLabel
          label={nameForFilter}
          key={`${nameForFilter}-formControl`}
          control={
            <Checkbox
              color="success"
              key={`${nameForFilter}-checkbox`}
              checked={checked}
              onChange={handleChange}
              inputProps={{ "aria-label": `controlled-checkbox-${nameForFilter}` }}
            />
          }
        />
      );
    };

    if (props.videosByTrimList != null) {
      return Object.keys(props.videosByTrimList).map((name) => {
        const itemCount = props.videosByTrimList[name].length;
        let filterName = name == "NULL" ? `Unknown (${itemCount})` : `${name} (${itemCount})`;
        if (itemCount > 0) {
          // console.log("Filter name and count:", name, itemCount);
          return (
            <Box key={`${filterName}-filter-box`} sx={{ display: "flex", flexDirection: "row", ml: 0 }}>
              {CheckBoxFilters(name, props.addToTrimsToFilter, props.trimsToFilter, filterName)}
            </Box>
          );
        }
      });
    } else {
      return null
    }
  };

  const BrandsFilterRender = (props) => {
    const CheckBoxFilters = (name, addToBrandsToFilter, brandsToFilter) => {
      const handleChange = (event) => {
        addToBrandsToFilter(name, event.target.checked);
      };

      let checked = true;
      if (brandsToFilter.includes(name)) {
        checked = false;
      }

      return (
        <FormControlLabel
          label={name}
          key={`${name}-formControl`}
          control={
            <Checkbox
              color="success"
              key={`${name}-checkbox`}
              checked={checked}
              onChange={handleChange}
              inputProps={{ "aria-label": `controlled-checkbox-${name}` }}
            />
          }
        />
      );
    };

    return props.brandsList.map((name) => {
      return (
        <Box key={`${name}-filter-box`} sx={{ display: "flex", flexDirection: "row", ml: 0 }}>
          {CheckBoxFilters(name, props.addToBrandsToFilter, props.brandsToFilter)}
        </Box>
      );
    });
  };

  return (
    <Paper elevation={4} sx={{ height: "100%" }}>
      <Card sx={{ height: "100%" }}>
        <CardContent>
          <Typography variant="h4">Filters</Typography>
          <hr />
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
              <Typography> Vehicle Trim </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TrimFilterRender
                videosByTrimList={props.videosByTrimList}
                brandsList={props.brandsList}
                addToTrimsToFilter={props.addToTrimsToFilter}
                trimsToFilter={props.trimsToFilter}
              />
            </AccordionDetails>
          </Accordion>
          <hr />
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
              <Typography> Part Brand </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <BrandsFilterRender
                brandsList={props.brandsList}
                addToBrandsToFilter={props.addToBrandsToFilter}
                brandsToFilter={props.brandsToFilter}
              />
            </AccordionDetails>
          </Accordion>
        </CardContent>
      </Card>
    </Paper>
  );
};

export default VideosFilter;
